import ZeissTable from '@components/table';
import { ROLEADMIN_COLUMNS } from './columns';
import './index.scss';
import { PaginationProps, message } from 'antd';
import type { TableProps } from 'antd';
import { useImmer } from 'use-immer';
import { DeletePrompt } from '@components/Popup/Prompt/deletePrompt';
import { useEffect, useState } from 'react';
import { queryUserList } from '@api/roleManagement';
import { ROLEIDLIST } from '../type';
import { delUser } from '@api/permission';
interface RecordData {
  username?: string;
  email?: string;
  phone?: string;
  userId?: string;
}

interface PageProps {
  pageNumber: number;
  pageSize: number;
}

export const useRoleAdmin = ({ roleIdList, refreshTable }: ROLEIDLIST) => {
  const [data, setData] = useImmer([]);
  const [delUserId, setDelUserId] = useState('');
  const [open, setOpen] = useState(false);
  const [total, setTotal] = useState<number>(0);
  const [pageInfo, setPageInfo] = useImmer<PageProps>({
    pageNumber: 1,
    pageSize: 10
  });
  //分页
  const pageProps: PaginationProps = {
    current: pageInfo.pageNumber,
    pageSize: pageInfo.pageSize,
    total: total
  };

  //显示删除框
  const handleClickDel = (id: string) => {
    setOpen(true);
    setDelUserId(id);
  };

  const columns: TableProps<RecordData>['columns'] = [
    ...ROLEADMIN_COLUMNS,
    {
      title: '操作',
      key: 'action',
      width: '15%',
      align: 'center',
      render: (record: RecordData) => (
        <div
          className="pc-roleAdmin-del"
          onClick={() => handleClickDel(record?.userId || '')}
        >
          删除
        </div>
      )
    }
  ];

  const getDataSource = async (current = null, pageSize = null) => {
    const res = await queryUserList({
      ...pageInfo,
      pageNumber: current || 1,
      pageSize: pageSize || 10,
      roleId: roleIdList?.Admin?.roleId
    });
    setPageInfo({
      pageNumber: current || 1,
      pageSize: pageSize || 10
    });
    setTotal(res?.users?.total);
    setData(res?.users?.records || []);
  };

  const deleteAccount = async () => {
    await delUser({
      userIds: [delUserId]
    });
    setOpen(false);
    message.success('删除成功!');
    getDataSource();
  };

  const handleChange = ({ current, pageSize }: any) => {
    getDataSource(current, pageSize);
  };

  useEffect(() => {
    if (roleIdList.Admin !== undefined) getDataSource();
  }, [roleIdList.Admin]);

  useEffect(() => {
    if (refreshTable && roleIdList.Admin) getDataSource(); //新增后刷新页面
  }, [refreshTable]);

  const roleAdminComponent = (
    <>
      <ZeissTable
        columns={columns}
        dataSource={data}
        bordered={false}
        onChange={handleChange}
        pagination={pageProps}
      />
      <DeletePrompt
        popupTitle="确认删除该账号？"
        open={open}
        setOpen={setOpen}
        confirmCallback={deleteAccount}
      />
    </>
  );

  return {
    roleAdminComponent
  };
};
